import { authenticatedGet } from "../../../../api/authenticatedFetch";

const BASE = "/api/v1/forecast-explorer";

export const getSeries = (group, horizon) =>
  authenticatedGet(`${BASE}/series`, { group, horizon });

export const getSeriesDetail = (name, horizon) =>
  authenticatedGet(`${BASE}/series/${encodeURIComponent(name)}`, { horizon });

export const getBudgets = (horizon) =>
  authenticatedGet(`${BASE}/budgets`, { horizon });

export const getBudgetDetail = (id, horizon) =>
  authenticatedGet(`${BASE}/budgets/${encodeURIComponent(id)}`, { horizon });

export const getAllocationSources = (horizon = 90) =>
  authenticatedGet(`${BASE}/allocation-sources`, { horizon });
